<admin-env-label></admin-env-label>
<header class="admin-header navbar">
  <button type="button"
          class="admin-header__toggle btn btn-link d-lg-none"
          (click)="layoutService.toggleSidebar()"
          [attr.aria-expanded]="layoutService.sidebarOpen"
          aria-controls="admin-sidebar"
          aria-label="Visa eller dölj meny">
    <i class="bi bi-list" aria-hidden="true"></i>
  </button>

  <div class="ms-auto d-flex align-items-center gap-3">
    <a [href]="publicUrl" class="text-secondary" title="Visa på webbplats">
      <i class="bi bi-globe fs-5" aria-hidden="true"></i>
    </a>
    <div class="d-flex align-items-center gap-2">
      <img id="kov-user-image"
           class="admin-header__avatar rounded-circle"
           [src]="user?.avatar || 'assets/images/anonymous_user.png'"
           alt="">
      <span class="small text-dark">{{ user != null ? user.displayName : 'Ej Inloggad' }}</span>
    </div>
  </div>
</header>
